module.exports = __webpack_public_path__ + "static/media/2020.12.18环卫所助力二居清理路面.c3dfe1bf.jpg";